// eslint-disable-next-line import/prefer-default-export
export function serialNumberFormatter(currentSerialNumber: string): string {
  let formatSerialNumber = currentSerialNumber.slice(0, 11).replaceAll('-', '');

  if (formatSerialNumber.length > 3 && formatSerialNumber.length <= 6)
    formatSerialNumber = `${formatSerialNumber.slice(0, 3)}-${formatSerialNumber.slice(3)}`;
  else if (currentSerialNumber.length > 6)
    formatSerialNumber = `${formatSerialNumber.slice(0, 3)}-${formatSerialNumber.slice(
      3,
      6
    )}-${formatSerialNumber.slice(6)}`;

  return formatSerialNumber;
}

type CurrentTX = {
  amountCents: number;
  surchargeAmount: number;
  bankCashAmount: number;
  tipAmount: number;
  preAuthAmount?: number;
};

export const calculateTotalAmount = (currentTransaction: CurrentTX): number => {
  const { amountCents, surchargeAmount, bankCashAmount, tipAmount } = currentTransaction;
  const totalAmount = amountCents + (surchargeAmount ?? 0) + (bankCashAmount ?? 0) + (tipAmount ?? 0);

  return totalAmount;
};

export const calculateCashoutOnlyTotalAmount = (currentTransaction: CurrentTX): number => {
  const { amountCents, surchargeAmount } = currentTransaction;
  const totalAmount = amountCents + (surchargeAmount ?? 0);

  return totalAmount;
};

const DEFAULT_MASK = '••••••';

function groupEveryFour(value: string): string {
  return value.match(/.{1,4}/g)?.join(' ') ?? value;
}
export function formatMaskedCardNumber(
  panFirst6?: string,
  panLast4?: string,
  mask: string = DEFAULT_MASK
): string | undefined {
  if (!panFirst6 || !panLast4) {
    return undefined;
  }
  if (panFirst6.length !== 6 || panLast4.length !== 4) {
    return undefined;
  }
  const combined = `${panFirst6}${mask}${panLast4}`;
  return groupEveryFour(combined);
}

export function formatTitleCase(value?: string): string | undefined {
  if (!value) {
    return undefined;
  }
  return value
    .replace(/_/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}
